import { useTranslation } from "react-i18next";
import { SEARCH_ITEMS } from "~/types/search.types";
import { Language } from "~/providers/LanguageProvider";

const useDefaultAllDisclosures = () => {
    const { t } = useTranslation();
    const allDisclosuresLabel = t("searchForm.labelAllDisclosures");

    const DEFAULT_ALL_DISCLOSURES = {
        id: -1,
        exploreId: -1,
        type: SEARCH_ITEMS.DISCLOSURE,
        label: {
            [Language.EN]: allDisclosuresLabel,
            [Language.FR]: allDisclosuresLabel,
        },
        isSelected: false,
        count: 0,
        selectedCategories: <number[]>[],
    };

    return {
        DEFAULT_ALL_DISCLOSURES,
        allDisclosuresLabel,
    }
}

export default useDefaultAllDisclosures;
